import SectionInspection from './SectionInspection';

export default function EngineInspection() {
  return (
    <SectionInspection
      section="engine"
      title="فحص الماكينة"
      saveEndpoint="engine"
    />
  );
}
